export default __webpack_public_path__ + "static/media/lh.24e55bb6.svg";